<div class="pitchin-icon pitchin-icon-close" (click)="close()"></div>
<div class="row m-0 mb-4 border-bottom company-name-panel">
  <div class="col-12 d-flex align-items-center">
    <div class="mr-4">
      <img class="logo-image" [src]="shareDetails.companyLogo || defaultLogo" />
    </div>
    <div>
      <h1 class="campaign-title">
        {{ shareDetails.companyName }}
        <span class="font-size-smaller font-grey">({{ shareDetails.registrationNumber }})</span>
      </h1>
      <div class="font-size-smaller">
        {{ 'mysec.tickerCode' | translate }}:
        <span class="text-black font-weight-extrabold">{{ shareDetails.tickerCode }}</span>
      </div>
    </div>
  </div>
</div>
<div class="row m-0 px-4 pb-3">
  <div class="col-12">
    <div class="text-uppercase font-size-small font-weight-bold">
      {{ 'mysec.shareDetails' | translate }}
    </div>
  </div>
</div>
<div class="row m-0 px-4 font-size-smaller pb-2">
  <div class="col-6">{{ 'mysec.shareQty' | translate }}</div>
  <div class="col-6 text-right text-black font-weight-bold">
    {{ shareDetails.shareQty | number }}
  </div>
</div>
<div class="row m-0 px-4 font-size-smaller pb-2">
  <div class="col-6">{{ 'mysec.purchasedPrice' | translate }}</div>
  <div class="col-6 text-right text-black font-weight-bold">
    {{ shareDetails.purchasedPrice | numberSuffix }}
  </div>
</div>
<div class="row m-0 px-4 font-size-smaller pb-2">
  <div class="col-6">{{ 'mysec.marketPrice' | translate }}</div>
  <div class="col-6 text-right text-black font-weight-bold">
    {{ shareDetails.marketPrice | numberSuffix }}
  </div>
</div>
<div class="row m-0 px-4 font-size-smaller pb-2">
  <div class="col-6">{{ 'mysec.unrealizedProfitLoss' | translate }}</div>
  <div class="col-6 text-right text-black font-weight-bold">
    <span
      [class.text-primary]="shareDetails.profit < 0"
      [class.text-profit]="shareDetails.profit >= 0"
    >
      {{
        (shareDetails.profit < 0 ? -1 * shareDetails.profit : shareDetails.profit) | numberSuffix
      }}
    </span>
  </div>
</div>
<div class="row m-0 px-4 font-size-smaller pb-5">
  <div class="col-6">{{ 'mysec.tradeTime' | translate }}</div>
  <div class="col-6 text-right text-black font-weight-bold">
    {{ shareDetails.tradeTime | amDateFormat: 'DD MMM yyyy, hh:mm a' }}
  </div>
</div>
<div class="row m-0 px-4 pb-5">
  <div class="col-6 pr-2">
    <div class="btn btn-lightgreen w-100 text-uppercase" (click)="bid()">
      {{ 'mysec.Bid' | translate }}
    </div>
  </div>
  <div class="col-6 pl-2">
    <div class="btn btn-lightred w-100 text-uppercase" (click)="offer()">
      {{ 'mysec.Sell' | translate }}
    </div>
  </div>
</div>
